import { ActionIcon, rem, Text } from "@mantine/core";
import { Flex } from "../../../styled";
import { IconPlus } from "@tabler/icons-react";
import useItemsPerRow from "./useItemsPerRow";
import { useMemo } from "react";
import { chunkArray } from "./VitalsList.utils";
import { useTheme } from "../../../hooks";
interface Props {
  renderInput: (index: number, item: any) => JSX.Element;
  list: any[];
  tag: string;
  suffix?: string;
  handleAdd?: () => void;
}
const VitalsListRenderer = ({
  renderInput,
  list,
  tag,
  suffix,
  handleAdd,
}: Props) => {
  const theme = useTheme();
  const { containerRef, itemsPerRow } = useItemsPerRow(60, 10);

  const rows = useMemo(
    () => chunkArray(list, handleAdd ? itemsPerRow : 15),
    [list, itemsPerRow],
  );
  if (rows.length === 0) return null;

  return (
    <Flex
      direction="column"
      gap={rem(10)}
      style={{ width: "100%" }}
      ref={containerRef}>
      {rows.map((row, rowIndex) => (
        <Flex key={rowIndex} align="center" gap={rem(10)}>
          {tag === "med_pressure" ? (
            <Flex
              direction="column"
              justify="space-between"
              gap={rem(15)}
              style={{ minWidth: rem(30), marginTop: rem(15) }}>
              <p style={{ margin: 0 }}>SYS</p>
              <p style={{ margin: 0 }}>DIA</p>
            </Flex>
          ) : (
            <p
              style={{
                minWidth: rem(30),
                margin: 0,
                marginTop: rem(15),
                color: "var(--mantine-color-dimmed)",
              }}>
              {suffix ?? ""}
            </p>
          )}
          {row.map(
            (item, index) =>
              item && renderInput(rowIndex * itemsPerRow + index, item),
          )}
          {rowIndex === rows.length - 1 && handleAdd && (
            <ActionIcon
              onClick={handleAdd}
              style={{ color: theme.colors.main[9], marginTop: rem(15) }}>
              <IconPlus />
            </ActionIcon>
          )}
        </Flex>
      ))}
    </Flex>
  );
};
export default VitalsListRenderer;
